// styles/pdfStyles.js
import { StyleSheet } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import NotoSans from '../../../fonts/NotoSansDevanagari-VariableFont_wdth,wght.ttf';
import Arial from '../../../fonts/ARIAL.TTF';
import ArialBold from '../../../fonts/ARIALBD.TTF';
import ArialItalic from '../../../fonts/ARIALI.TTF';
import ArialBlack from '../../../fonts/ARIBLK.TTF';




// Register Noto Sans Devanagari font

Font.register({
  family: 'NotoSans',
  src: NotoSans,
});


Font.register({
  family: 'Arial',
  src: Arial,
});


Font.register({
  family: 'ArialBold',
  src: ArialBold,
});


Font.register({
    family: 'ArialItalic',
    src: ArialItalic,
  });

  Font.register({
    family: 'ArialBlack',
    src: ArialBlack,
  });

    

export const style = StyleSheet.create({
  // Base styles
  page: {
    padding: 40,
    marginLeft: 20,
    fontSize: 10,
    lineHeight: 1.5,
  },
  
  // Text variants
  title: {
    fontSize: 14,
    marginBottom: 5,
    textAlign: 'center',
  },

  subtitle: {
    fontSize: 8,
    marginBottom: 5,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  paragraph: {
    marginBottom: 8,
    textAlign: 'justify'
  },

  solidLine: {
    marginTop: 2,
    marginBottom: 5,    // space above and below the line
    borderBottomWidth: 2,   // thickness of the line
    borderBottomColor: '#000', // color (black here)
    width: '100%',         // full width of page or container
  },
  signature: {
    textAlign: 'right',     
    marginRight: 50,         
    fontSize: 8,
  },
  marathi: {
    fontFamily: 'NotoSans',
  },
  ArialBold: {
    fontFamily: 'ArialBold',
  },
  ArialItalic: {
    fontFamily: 'ArialItalic',
  },
    ArialBlack: {
        fontFamily: 'ArialBlack',
    },

});
